/** A scraped or crawled address the page may link to or load: its normalized href when it is http(s), else null. */
export function safeHttpUrl(u: string | null | undefined): string | null {
  if (!u) return null;
  try {
    const url = new URL(u);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null;
  } catch {
    return null;
  }
}

/** An address an <img> may load: http(s), or an inline data:image (the built-in sample's photos). Never a link target. */
export function safeImageUrl(u: string | null | undefined): string | null {
  return u && /^data:image\//i.test(u) ? u : safeHttpUrl(u);
}
